<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="getData()">刷新</el-button>
            </div>
            <div class="header-right">
                <el-input v-model="filterParams.nickname" placeholder="请输入用户昵称" class="header-input" @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column label="序号" width="70">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="videoUrl" label="视频URL" width="182">
                <template slot-scope="scope">
                    <video :src="frontUrl + scope.row.videoUrl" style="width: 160px; height: 120px; cursor: pointer;" @click="videoOpen(scope.row)"></video>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="type" label="类型" width="80"></el-table-column> -->
            <el-table-column prop="prompt" label="提示词"></el-table-column>
            <el-table-column prop="params" label="参数"></el-table-column>
            <el-table-column prop="status" label="状态" width="80"></el-table-column>
            <el-table-column prop="creditsCost" label="花费" width="70"></el-table-column>
            <el-table-column prop="taskId" label="任务ID" width="210"></el-table-column>
            <el-table-column prop="createdAt" label="创建日期" width="160">
                <template slot-scope="scope">
                    {{ getFormatDate(scope.row.createdAt) }}
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog title="视频播放" :visible.sync="isVideo" width="60%" :close-on-click-modal="true">
            <video :src="frontUrl + videoUrl" style="width: 100%;" controls></video>
        </el-dialog>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"

import { API, doGet } from "@/api/api.js"

export default {
    mixins: [verifyMixin, listMixin],
    data: function () {
        return {
            isVideo: false,
            videoUrl: "",
            statusArray: [
                { value: 'active', label: '正常' },
                { value: 'banned', label: '已禁用' }
            ]
        }
    },
    methods: {
        videoOpen: function(row) {
            this.videoUrl = row.videoUrl;
            this.isVideo = true;
        },
        getData: async function() {
            this.initialData();
        }
    },
    created: function () {
        this.tag = "GENERATIONS";
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
</style>